<ng-template #templateRef
             let-columns>
  <tr>
    <td [ngClass]="{ 'w-full': tableSettings.scrollable }"
        [attr.colspan]="columns.length + staticColumnsLength">
      <ng-container i18n>{{tableSettings.emptyMessageText || 'No records found.'}}</ng-container>
    </td>
  </tr>
</ng-template>